import { createUseParams } from 'utils/createUseParams';
import { flattenRoutes } from 'utils/flattenRoutes';

/**
 * TODO If you ever change this route, please update `marketing` section in `moduleRoutes` of
 * `app/src/rdx/analytics/applicationRoutes.ts` accordingly
 */

export const routes = flattenRoutes({
  index: '/marketing/promotions',
  list: 'list',
  addPromotion: 'add',
  details: {
    index: 'details/:promotionId',
    useParams: createUseParams<{ promotionId: unknown }>(),
  },
});
